import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomTextField from "../components/CustomTextField";
import ReactHookFormSelect from "../components/ReactHookFormSelect";
import { useTranslation } from "react-i18next";
import CustomCheckBox from "../components/CustomCheckBox";
import SearchableAutoComplete from "../components/SearchableAutoComplete";
import usePincode from "../hooks/usePincode";
import axios from "axios";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};
const AddressDetail = ({ presentAddressFields, validationFields, isEdit, cafEnabled = false }) => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext({
    mode: "onChange",
  });

  const sameAsPresentAddress = watch("sameAsPresentAddress");
  const pinCode = watch("pinCode");

  const {
    autoSearchPincode,
    pincodeAutoSearchResults,
    isLoadingAutoSearch: loadingPincode,
  } = usePincode();

  useEffect(() => {
    if (!cafEnabled) {
      if (sameAsPresentAddress) {
        console.log(presentAddressFields[1], "presentAddressFields[1]");
        setValue("insDoorNo", presentAddressFields[0]);
        setValue("insPinCode", presentAddressFields[1]);
        setValue("insArea", presentAddressFields[2]);
        setValue("insCity", presentAddressFields[3]);
        setValue("insState", presentAddressFields[4]);
        setValue("insCountry", presentAddressFields[5]);
      } else {
        setValue("insDoorNo", "");
        setValue("insPinCode", "");
        setValue("insArea", "");
        setValue("insCity", "");
        setValue("insState", "");
        setValue("insCountry", "");
      }
    }
  }, [sameAsPresentAddress]);

  const [pincode, setPincode] = useState("");
  const [postOffices, setPostOffices] = useState([]);
  const [installPostOffices, setInstallPostOffices] = useState([]);
  const [selectedPostOffice, setSelectedPostOffice] = useState("");
  const [selectedInstallPostOffice, setSelectedInstallPostOffice] = useState("");

  const [pinResults, setPinResults] = useState([]);

  const [payload, setPayload] = useState(currentPayload);
  const [statePayload, setStatePayload] = useState(currentPayload);

  useEffect(() => {
    autoSearchPincode(payload);
  }, [payload]);

  const [city, setCity] = useState("");
  const [state, setState] = useState("Karnataka");
  const [country, setCountry] = useState("India");

  const [installPincode, setInstallPincode] = useState("");
  const [installCity, setInstallCity] = useState("");
  const [installState, setInstallState] = useState("");
  const [installCountry, setInstallCountry] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    if (pincodeAutoSearchResults.data.length !== 0) {
      setPinResults([...pinResults, ...pincodeAutoSearchResults.data]);
    }
  }, [pincodeAutoSearchResults]);

  useEffect(() => {
    setValue("state", "Karnataka");
    setValue("country", "India");
  }, []);

  const searchInputChange = (data) => {
    console.log(data, "searchInputChange");
    let filters = [];
    filters.push({
      fieldName: "pincodeName",
      fieldValue: data,
      op: "like",
      dataType: "string",
      condition: "and",
      isJoin: false,
    });
    setPayload({
      ...payload,
      filters: filters,
      pagination: {
        pageNumber: 1,
        pageSize: 100,
      },
    });
  };

  useEffect(() => {
    //console.log(pinCode?.label);
    if (pinCode != undefined && pinCode?.label?.length === 6) {
      axios
        .get(`https://api.postalpincode.in/pincode/${pinCode?.label}`)
        .then((response) => {
          const data = response.data[0];
          if (data.Status === "Success") {
            setPostOffices(data.PostOffice);
            setValue("state", data.PostOffice[0]?.State || "");
            setValue("country", data.PostOffice[0]?.Country || "");
          } else {
            setPostOffices([]);
            setValue("state", "");
            setValue("country", "");
          }
        })
        .catch(() => {
          setPostOffices([]);
          setValue("state", "Karnataka");
          setValue("country", "India");
        });
    }
  }, [pinCode]);

  console.log("pinnccc", pincode);

  return (
    <Grid container spacing={12} className="row" pt={8}>
      <Grid item md={6}>
        <CustomTextField
          label="Old Address"
          name="oldAddress"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          disabled={true}
        />
      </Grid>
      <Grid item md={6}>
        <CustomTextField
          label={t("door_no")}
          name="doorNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SearchableAutoComplete
          control={control}
          data={pinResults}
          label={t("pincode_name")}
          payload={payload}
          setPayload={setPayload}
          loading={loadingPincode}
          name="pinCode"
          fields={validationFields}
          multiple={false}
          hasNextPage={pincodeAutoSearchResults?.paging?.hasNextPage}
          searchInputChange={searchInputChange}
          searchLength="3"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {postOffices.length > 0 ? (
          <ReactHookFormSelect
            name="area"
            label={t("select_area")}
            control={control}
            fields={validationFields}
            fullWidth
            variant="outlined"
            errors={errors}
          >
            {postOffices.map((po) => (
              <MenuItem key={po.Name} value={po.Name}>
                {po.Name}
              </MenuItem>
            ))}
          </ReactHookFormSelect>
        ) : (
          <CustomTextField
            label={t("select_area")}
            name="area"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        )}
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("city_town")}
          name="city"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("state")}
          name="state"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("country")}
          name="country"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>

      <Grid item md={12}>
        <CustomCheckBox
          label="Same as present address"
          name="sameAsPresentAddress"
          type="checkbox"
          my={2}
          fullWidth
          errors={errors}
          fields={validationFields}
        />
      </Grid>

      <Grid item md={6}>
        <CustomTextField
          label={t("door_no")}
          name="insDoorNo"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SearchableAutoComplete
          control={control}
          data={pinResults}
          label={t("pincode_name")}
          payload={payload}
          setPayload={setPayload}
          loading={loadingPincode}
          name="insPinCode"
          fields={validationFields}
          multiple={false}
          hasNextPage={pincodeAutoSearchResults?.paging?.hasNextPage}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        {postOffices.length > 0 ? (
          <ReactHookFormSelect
            name="insArea"
            label={t("select_area")}
            control={control}
            fields={validationFields}
            fullWidth
            variant="outlined"
            errors={errors}
          >
            {postOffices.map((po) => (
              <MenuItem key={po.Name} value={po.Name}>
                {po.Name}
              </MenuItem>
            ))}
          </ReactHookFormSelect>
        ) : (
          <CustomTextField
            label={t("select_area")}
            name="insArea"
            control={control}
            fullWidth
            variant="outlined"
            errors={errors}
            fields={validationFields}
          />
        )}
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("city_town")}
          name="insCity"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("state")}
          name="insState"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label={t("country")}
          name="insCountry"
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
    </Grid>
  );
};

export default AddressDetail;
